// Function presets (comprehensive, one per function type)
export * from './linear.preset';
export * from './quadratic.preset';
export * from './cubic.preset';
export * from './absolute.preset';
export * from './sqrt.preset';
export * from './exponential.preset';
export * from './logarithmic.preset';
export * from './sine.preset';
export * from './cosine.preset';
export * from './tangent.preset';

// Feature test presets
export * from './test-calculus.preset';
export * from './test-integral.preset';
export * from './test-intersection-area.preset';
export * from './test-trajectory.preset';
export * from './test-snapping-translation.preset';

// Legacy presets (kept for backwards compatibility)
export * from './quadratic-exploration.preset';
export * from './quadratic-exploration-abc.preset';
export * from './linear-exploration.preset';

import type { GraphpadWidgetConfig } from '../graphpad.model';

import { LINEAR_PRESET } from './linear.preset';
import { QUADRATIC_PRESET } from './quadratic.preset';
import { CUBIC_PRESET } from './cubic.preset';
import { ABSOLUTE_PRESET } from './absolute.preset';
import { SQRT_PRESET } from './sqrt.preset';
import { EXPONENTIAL_PRESET } from './exponential.preset';
import { LOGARITHMIC_PRESET } from './logarithmic.preset';
import { SINE_PRESET } from './sine.preset';
import { COSINE_PRESET } from './cosine.preset';
import { TANGENT_PRESET } from './tangent.preset';

import { TEST_CALCULUS_PRESET } from './test-calculus.preset';
import { TEST_INTEGRAL_PRESET } from './test-integral.preset';
import { TEST_INTERSECTION_AREA_PRESET } from './test-intersection-area.preset';
import { TEST_TRAJECTORY_PRESET } from './test-trajectory.preset';
import { TEST_SNAPPING_TRANSLATION_PRESET } from './test-snapping-translation.preset';

/**
 * All available Graphpad presets.
 */
export const GRAPHPAD_PRESETS: GraphpadWidgetConfig[] = [
  // Function presets (comprehensive)
  LINEAR_PRESET,
  QUADRATIC_PRESET,
  CUBIC_PRESET,
  ABSOLUTE_PRESET,
  SQRT_PRESET,
  EXPONENTIAL_PRESET,
  LOGARITHMIC_PRESET,
  SINE_PRESET,
  COSINE_PRESET,
  TANGENT_PRESET,

  // Feature test presets
  TEST_CALCULUS_PRESET,
  TEST_INTEGRAL_PRESET,
  TEST_INTERSECTION_AREA_PRESET,
  TEST_TRAJECTORY_PRESET,
  TEST_SNAPPING_TRANSLATION_PRESET,
];

export type GraphpadPresetId = (typeof GRAPHPAD_PRESETS)[number]['id'];
